const ar = {
  common: {
    loading: "جارٍ التحميل...",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    confirm: "تأكيد",
    back: "رجوع",
    search: "بحث",
    all: "الكل",
    yes: "نعم",
    no: "لا",
    done: "تم",
    error: "خطأ",
    success: "نجاح",
    retry: "إعادة المحاولة",
    copy: "نسخ",
    copied: "تم النسخ",
    viewAll: "عرض الكل",
    noData: "لا توجد بيانات",
    unknownError: "حدث خطأ غير معروف",
    required: "هذا الحقل مطلوب",
    optional: "اختياري",
    amount: "المبلغ",
    price: "السعر",
    quantity: "الكمية",
    status: "الحالة",
    date: "التاريخ",
    actions: "الإجراءات",
    today: "اليوم",
    last7days: "آخر 7 أيام",
    last30days: "آخر 30 يوم",
    noResults: "لا توجد نتائج",
    available: "متاح",
    codes: "الأكواد",
    count: "العدد",
    total: "المجموع",
    unavailable: "غير متوفر",
    options: "خيارات",
    view: "عرض",
    delete: "حذف",
    copyNumber: "نسخ الرقم",
    copyCode: "نسخ الكود",
    cardNotFound: "البطاقة غير موجودة",
    discount: "خصم {{discount}}%",
    shippedFast: "يتم الشحن عبر الايدي بشكل سريع",
    unknown: "غير معروف",
  },
  nav: {
    brandSub: "منصة البطاقات الرقمية",
    menu: "القائمة",
    services: "الخدمات",
    home: "الرئيسية",
    wallet: "المحفظة",
    orders: "الطلبات",
    deposit: "إضافة رصيد",
    balance: "رصيد",
    virtualNumbers: "الأرقام المؤقتة",
    agents: "الوكلاء",
    support: "الدعم الفني",
    notifications: "الإشعارات",
    favorite: "المفضلة",
    profile: "ملفي الشخصي",
    logout: "خروج",
  },
  header: {
    menu: "القائمة",
    notifications: "الإشعارات",
    darkMode: "الوضع الداكن",
    lightMode: "الوضع الفاتح",
    language: "اللغة",
    changeLanguage: "تغيير اللغة",
  },
  auth: {
    brandTagline: "منصة البطاقات الرقمية الأولى في المنطقة",
    brandDesc: "اشترِ وأرسل واستلم بطاقاتك وباقاتك فوراً، بأمان وسرعة.",
    feature1: "تسليم فوري وآمن",
    feature2: "حماية كاملة للحساب",
    feature3: "أفضل الأسعار يومياً",
    loginTitle: "تسجيل الدخول",
    loginSub: "أدخل بياناتك للوصول إلى لوحة التحكم.",
    email: "البريد الإلكتروني",
    emailPlaceholder: "name@tstore.com",
    password: "كلمة المرور",
    passwordPlaceholder: "••••••••",
    showPassword: "إظهار كلمة المرور",
    rememberMe: "تذكرني",
    forgotPassword: "نسيت كلمة المرور؟",
    login: "دخول",
    or: "أو",
    google: "جوجل",
    facebook: "فيسبوك",
    noAccount: "ليس لديك حساب؟",
    createAccount: "أنشئ حساباً الآن",
    loginError: "يوجد خطأ بالايميل او كلمة السر",
    registerTitle: "إنشاء حساب",
    registerSub: "أكمل بياناتك لإنشاء حساب جديد.",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    registerSubGate: "أدخل بياناتك للبدء باستخدام المنصة.",
    registerDone: "تم استلام طلب التسجيل (واجهة تجريبية).",
    pwHint: "استخدم 8 أحرف على الأقل مع رمز ورقم.",
    terms: "أوافق على شروط الخدمة وسياسة الخصوصية.",
    termsOfService: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
    orRegisterWith: "أو سجّل عبر",
    joinTagline: "انضم إلى منصة البطاقات الرقمية الأولى في المنطقة",
    joinDesc: "أنشئ حسابك في ثوانٍ واحصل على بطاقاتك وباقاتك فوراً، بأمان وسرعة.",
    name: "الاسم",
    confirmPassword: "تأكيد كلمة المرور",
    register: "تسجيل",
    haveAccount: "لديك حساب بالفعل؟",
    loginInstead: "سجّل الدخول",
    registerSuccess: "تم إنشاء الحساب بنجاح",
    passwordMismatch: "كلمتا المرور غير متطابقتين",
    registerMissing: "الرجاء تعبئة الاسم والبريد وكلمة المرور.",
    registerPassMismatch: "كلمتا المرور غير متطابقتين.",
    registerFailed: "تعذر إنشاء الحساب، حاول مرة أخرى.",
  },
  home: {
    crumbHome: "الرئيسية",
    crumbOverview: "نظرة عامة",
    welcome: "أهلاً {{name}} 👋",
    welcomeDesc: "إليك ملخص حسابك وآخر البطاقات المتاحة اليوم.",
    history: "سجل العمليات",
    charge: "اشحن رصيدك",
    news: "أخبار",
    currentBalance: "الرصيد الحالي",
    featured: "البطاقات والباقات المميزة",
    availableCards: "البطاقات المتوفرة",
    categories: "التصنيفات",
    chooseCategory: "تصفّح الأقسام",
    allCategories: "الكل",
    noCardsInCategory: "لا توجد بطاقات في هذا التصنيف",
    allCards: "كل البطاقات",
    latestOrders: "أحدث الطلبات",
    fullHistory: "سجل كامل",
    orderId: "رقم الطلب",
    product: "المنتج",
    orderDate: "التاريخ",
    orderStatus: "الحالة",
    noOrders: "لا توجد طلبات بعد",
    stat: "إحصائية",
    statusCompleted: "مكتمل",
    statusCancelled: "ملغي",
    statusPending: "قيد التنفيذ",
  },
  wallet: {
    title: "المحفظة",
    balance: "رصيد المحفظة",
    balanceIn: "الوارد",
    balanceOut: "الصادر",
    pending: "قيد الانتظار",
    deposit: "إيداع",
    withdraw: "سحب",
    history: "سجل المعاملات",
    noHistory: "لا توجد معاملات بعد",
    reason: "السبب",
    transactionDate: "تاريخ العملية",
    transactionType: "نوع العملية",
    desc: "تفاصيل رصيدك وحركاته المالية.",
    pendingApproval: "بانتظار الموافقة",
    txnId: "رقم العملية",
    operation: "العملية",
    // ===== سجل حركات الرصيد (جدول واضح) =====
    type: "النوع",
    reference: "المرجع",
    details: "التفاصيل",
    amountEffect: "الأثر على الرصيد",
    balanceAfter: "الرصيد بعدها",
    refOrder: "طلب #{{id}}",
    refDeposit: "إيداع #{{id}}",
    refNone: "-",
    opDepositAccepted: "إيداع مقبول",
    opDepositOther: "إيداع",
    opPurchase: "شراء بطاقة",
    opRefund: "إرجاع مبلغ",
    opAdminAdd: "إضافة إدارية",
    opAdminRemove: "خصم إداري",
    opOther: "حركة رصيد",
    descDepositAccepted: "تم شحن رصيدك من طلب إيداع مقبول",
    descPurchase: "خصم قيمة شراء بطاقة",
    descRefund: "إرجاع مبلغ طلب ملغى أو مرفوض",
    descAdminAdd: "إضافة يدوية من الإدارة",
    descAdminRemove: "خصم من الإدارة",
    descGenericAdd: "إضافة إلى الرصيد",
    descGenericRemove: "خصم من الرصيد",
    // ===== سجل العميل الكامل (إيداعات وطلبات بكل حالاتها) =====
    opDepositPending: "إيداع قيد المراجعة",
    opDepositRejected: "إيداع مرفوض",
    opOrderPending: "طلب قيد التنفيذ",
    opOrderRejected: "طلب مرفوض",
    opOrderCompleted: "طلب مكتمل",
    descDepositPending: "طلب الإيداع بانتظار موافقة الإدارة",
    descDepositRejected: "تم رفض طلب الإيداع ولم يُضف أي رصيد",
    descOrderPending: "جارٍ معالجة طلبك",
    descOrderRejected: "تم رفض طلبك وأُعيد المبلغ إلى رصيدك",
    descOrderCompleted: "تم تنفيذ طلبك بنجاح",
    statusPendingReview: "قيد المراجعة",
    statusRejected: "مرفوض",
    statusAccepted: "مقبول",
    noEffect: "لا تغيير في الرصيد",
  },
  deposit: {
    title: "إضافة رصيد",
    methods: "طرق الإيداع",
    chooseMethod: "اختر طريقة الإيداع",
    amount: "المبلغ",
    enterAmount: "أدخل المبلغ",
    fee: "الرسوم",
    total: "الإجمالي",
    instructions: "تعليمات الدفع",
    confirmDeposit: "تأكيد الإيداع",
    depositSuccess: "تم إرسال طلب الإيداع",
    walletAddress: "عنوان المحفظة",
    qrCode: "رمز الاستجابة السريعة",
    crypto: "عملة رقمية",
    desc: "اختر طريقة الشحن المناسبة لك.",
    methodsAvailable: "طرق الشحن المتاحة",
    paymentMethod: "طريقة الدفع",
    completeTransferDesc: "أكمل بيانات التحويل ثم أكد الدفعة.",
    infoTitle: "معلومات الإيداع",
    fillTitle: "البيانات المطلوبة منك",
    noInfo: "لا توجد معلومات إيداع إضافية لهذه الطريقة.",
    commission: "العمولة",
    emailLabel: "البريد",
    orEmail: "أو البريد",
    recipientName: "اسم المستلم",
    phone: "الهاتف",
    city: "المدينة",
    scanBarcode: "امسح الباركود للتحويل:",
    scanQr: "امسح QR المحفظة للتحويل:",
    senderName: "اسم المرسل",
    amountWithFee: "قيمة المبلغ مع أجور التحويل",
    amountHint: "اكتب المبلغ الذي تريد إضافته إلى رصيدك (الذي سيصلنا فعلياً بعد خصم عمولة شركة التحويل). مثال: إذا دفعت 1005 للشركة ووصلنا 1000، اكتب 1000. تحويل العملة للدولار يتم من قبل الإدارة عند المراجعة.",
    amountHintCrypto: "أدخل المبلغ الذي تريد شحنه **بالدولار (USD)** — وهو ما سيُضاف إلى رصيدك. مثال: لشحن 100 دولار بعملة BTC، اكتب 100 (وليس قيمة الـ BTC). سيتم تحويل المبلغ تلقائياً إلى BTC (أو العملة التي تختارها) عبر NowPayments، والمبلغ بالدولار هو الذي يُضاف لرصيدك.",
    amountHintCryptoNote: "ملاحظة: لا تكتب قيمة العملة المشفرة (مثل 0.0015 BTC)، بل اكتب المبلغ بالدولار فقط. المزود يحسب المكافئ تلقائياً.",
    transferOffice: "مكتب التحويل",
    cryptoCurrency: "العملة المشفرة",
    noticeOrTransferNumber: "رقم الإشعار أو رقم الحوالة",
    note: "ملاحظة",
    notePlaceholder: "أي شيء",
    confirmPayment: "تأكيد الدفع",
    cryptoInvoiceFailed: "تعذر إنشاء فاتورة الدفع عبر المزود، حاول مرة أخرى أو تواصل مع الدعم.",
    amountRequired: "الرجاء إدخال مبلغ صحيح أكبر من صفر.",
    receiptRequired: "الرجاء إرفاق الإيصال المطلوب:",
    fieldRequired: "الرجاء تعبئة الحقل المطلوب:",
    submitFailed: "تعذر إرسال طلب الإيداع، حاول مرة أخرى.",
    done: "تم إرسال طلب الإيداع بنجاح.",
    pendingExists: "لديك طلب إيداع قيد المراجعة. يجب انتظار معالجته قبل إرسال طلب جديد.",
    turnstileFailed: "فشل التحقق من الحماية، أعد المحاولة.",
    uploadPdfHint: "ارفع ملف الإيصال (PDF أو صورة)",
    uploadImageHint: "ارفع صورة",
  },
  orders: {
    title: "الطلبات",
    all: "الكل",
    completed: "مكتمل",
    cancelled: "ملغي",
    pending: "قيد التنفيذ",
    delivered: "تم الاستلام",
    inProgress: "جاري التنفيذ",
    noOrders: "لا توجد طلبات",
    searchPlaceholder: "ابحث برقم الطلب أو المنتج",
    orderDetails: "تفاصيل الطلب",
    productName: "اسم المنتج",
    quantity: "الكمية",
    totalPrice: "السعر الإجمالي",
    orderDate: "تاريخ الطلب",
    status: "الحالة",
    code: "الكود",
    note: "ملاحظة",
    activation: "بيانات التفعيل",
    card: "البطاقة",
    desc: "تابع جميع طلباتك ومحفظتك.",
    allOrders: "كل الطلبات",
    incomplete: "غير مكتمل",
    filterPlaceholder: "بحث عن بطاقة أو ايدي لاعب أو رقم الطلب بدون #",
  },
  viewOrder: {
    orderId: "الطلب #{{id}}",
    desc: "تفاصيل طلبك والكود إن وُجد.",
    created: "بتاريخ",
    executed: "تاريخ التنفيذ",
    info: "معلومات الطلب",
    playerId: "ايدي اللاعب",
    item: "البطاقة",
    checkStatus: "فحص حالة الطلب",
    cancel: "الغاء الطلب",
  },
  profile: {
    title: "ملفي الشخصي",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    address: "العنوان",
    telegram: "معرف تيليغرام",
    avatar: "الصورة الشخصية",
    updateProfile: "تحديث البيانات",
    changePassword: "تغيير كلمة المرور",
    oldPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    profileUpdated: "تم تحديث البيانات بنجاح",
    passwordChanged: "تم تغيير كلمة المرور",
    desc: "إدارة معلومات حسابك وكلمة المرور",
    changePhoto: "تغيير الصورة",
    updateMyInfo: "تحديث معلوماتي الشخصية",
    fullName: "الاسم الكامل",
    changeCurrentPassword: "تغيير كلمة المرور الحالية",
    passwordHint: "الرجاء إدخال كلمة المرور الحالية أولاً، ثم إدخال كلمة المرور الجديدة",
    currentPw: "كلمة السر الحالية",
    newPw: "كلمة السر الجديدة",
    newPwPlaceholder: "ادخل كلمة السر الجديدة",
    confirmPwPlaceholder: "قم بتأكيد كلمة المرور الجديدة",
    passwordChangedSuccess: "تم تغيير كلمة المرور بنجاح",
  },
  tickets: {
    title: "الدعم الفني",
    newTicket: "تذكرة جديدة",
    ticketTitle: "عنوان التذكرة",
    priority: "الأولوية",
    low: "منخفض",
    medium: "متوسط",
    high: "عالي",
    message: "الرسالة",
    send: "إرسال",
    myTickets: "تذاكر الدعم",
    noTickets: "لا توجد تذاكر",
    open: "مفتوحة",
    closed: "مغلقة",
    reply: "رد",
    replyPlaceholder: "اكتب ردك هنا...",
    sendReply: "إرسال الرد",
    desc: "تابع تذاكر الدعم الخاصة بك أو افتح تذكرة جديدة",
    openNew: "فتح تذكرة جديدة",
    subject: "العنوان",
    ticket: "تذكرة",
    ticketId: "Id التذكرة",
    you: "أنت",
    support: "الدعم",
    writeComment: "اكتب تعليقك هنا",
    commentPlaceholder: "هنا....",
    sendComment: "إرسال التعليق",
  },
  notifications: {
    title: "الإشعارات",
    noNotifications: "لا توجد إشعارات",
    markAllRead: "تعليم الكل كمقروء",
    desc: "تابع آخر التنبيهات والرسائل",
  },
  favorite: {
    title: "المفضلة",
    empty: "لا توجد عناصر مفضلة",
    remove: "إزالة من المفضلة",
    desc: "بطاقاتك وباقاتك المفضلة",
    countRange: "أقل عدد هو {{min}} وأكبر عدد هو {{max}}",
    add: "إضافة إلى المفضلة",
    added: "مفضل",
  },
  search: {
    title: "البحث",
    placeholder: "ابحث عن بطاقة أو باقة...",
    desc: "ابحث عن البطاقات والباقات المتوفرة",
    noResults: "لا توجد نتائج",
    results: "نتائج البحث",
    homePlaceholder: "ابحث عن بطاقة، باقة، أو طلب...",
  },
  buy: {
    title: "شراء",
    item: "المنتج",
    quantity: "الكمية",
    total: "الإجمالي",
    buy: "شراء",
    playerId: "معرف اللاعب",
    email: "البريد الإلكتروني للاستلام",
    confirm: "تأكيد الشراء",
    buySuccess: "تم إنشاء الطلب بنجاح",
    available: "متوفر",
    buyNow: "شراء الان",
    desc: "اختر الباقة المناسبة وابدأ الشراء",
    messageLabel: "الرسالة:",
    codeLabel: "الكود:",
    stateLabel: "الحالة:",
    confirmPurchaseText: "قم بتأكيد الشراء",
    availableBalance: "رصيدك المتاح",
    playerIdPlaceholder: "معرف الحساب",
    email: "البريد الإلكتروني للاستلام",
    emailPlaceholder: "البريد الإلكتروني الذي سيُرسل إليه الكود/التفعيل",
    emailRequired: "البريد الإلكتروني مطلوب لإتمام هذا الطلب",
    playerIdRequired: "معرّف اللاعب مطلوب لإتمام هذا الطلب",
    phone: "رقم الهاتف",
    phonePlaceholder: "رقم الهاتف المطلوب للتفعيل",
    phoneRequired: "رقم الهاتف مطلوب لإتمام هذا الطلب",
    accountName: "اسم الحساب",
    accountNamePlaceholder: "اسم حساب اللاعب",
    productDetails: "تفاصيل المنتج",
    moreDetails: "تفاصيل موسعة",
    cardDetails: "تفاصيل البطاقة",
    minOrder: "أقل عدد يمكن طلبه هو: {{min}}",
    maxOrder: "أكبر عدد يمكن طلبه هو: {{max}}",
    bundleUnavailable: "هذه الباقة غير متوفرة حالياً",
    purchaseFailed: "تعذر إتمام عملية الشراء، حاول مرة أخرى",
  },
  orderResult: {
    titleSuccess: "تم استلام طلبك",
    codeTitle: "تم تسليم الكود بنجاح",
    codeDesc: "تم تنفيذ طلبك وسحب الكود مباشرةً. يمكنك نسخه أدناه، كما تم إرساله إلى بريدك الإلكتروني.",
    manualTitle: "تم تسجيل طلبك بانتظار التفعيل",
    manualDesc: "طلبك من نوع تحويل يدوي، سيقوم فريق الدعم بتنفيذه وتفعيله. ستصلك رسالة على بريدك الإلكتروني فور اكتمال التفعيل.",
    externalTitle: "جاري تنفيذ طلبك عبر المصدر الخارجي",
    externalDesc: "تم إرسال طلبك إلى المزوّد الخارجي وهو قيد المعالجة. ستتلقى إشعاراً بالبريد الإلكتروني عند اكتمال التنفيذ وورود الكود.",
    insufficientTitle: "رصيد غير كافٍ",
    insufficientDesc: "ليس لديك رصيد كافٍ لإتمام عملية الشراء. يرجى شحن رصيدك والمحاولة مجدداً.",
    sentToEmail: "تم إرسال الكود إلى بريدك: {{email}}",
    viewOrder: "تفاصيل الطلب",
    backHome: "العودة للرئيسية",
  },
  gateway: {
    title: "بوابة الدفع",
    choose: "اختر بوابة الدفع",
    pay: "ادفع الآن",
    processing: "جارٍ المعالجة...",
    desc: "أكمل عملية الشراء عبر البوابة.",
    hint: "اختر الباقة واكتب بريدك لإتمام العملية.",
    buyNow: "شراء الآن",
    selectAndEmail: "يرجى اختيار الباقة وكتابة البريد الإلكتروني",
  },
  virtualNumbers: {
    title: "الأرقام المؤقتة",
    country: "الدولة",
    service: "الخدمة",
    phone: "رقم الهاتف",
    price: "السعر",
    status: "الحالة",
    getNumber: "احصل على رقم",
    myActivations: "تفعيلاتي",
    noActivations: "لا توجد تفعيلات",
    code: "الكود",
    sms: "الرسالة",
    expires: "ينتهي في",
    activationTitle: "تفعيل الأرقام الافتراضية",
    desc: "احصل على رقم مؤقت لاستلام رموز تفعيل التطبيقات عبر SMS",
    active: "نشط",
    heroTitle: "أرقام افتراضية لتفعيل البرامج",
    heroDesc: "اختر الدولة والخدمة واستلم رمز التفعيل فورياً — بأفضل الأسعار.",
    searchPlaceholder: "ابحث عن تطبيق (واتساب، جوجل، تيك توك...)",
    getNumberError: "فشل في الحصول على رقم",
    noServices: "لا توجد خدمات مطابقة",
    viewPrices: "عرض الأسعار",
    chooseCountry: "اختر الدولة لشراء رقم تفعيل",
    noPrices: "لا توجد أسعار متاحة لهذه الخدمة حالياً",
    buyNumber: "اشترِ الرقم",
    recentActivations: "آخر التفعيلات",
    myActivationsDesc: "جميع أرقامك المؤقتة وتفاصيلها",
    buyNewNumber: "اشترِ رقماً جديداً",
    number: "الرقم",
    activationNotFoundTitle: "التفعيل غير موجود",
    activationDetails: "تفاصيل التفعيل",
    smsReceivedTitle: "SMS مستلم",
    checkSms: "التحقق من SMS",
    cancelNumber: "إلغاء الرقم",
    statusPendingSms: "بانتظار SMS",
    statusSmsReceived: "تم استلام SMS",
    statusCompleted: "مكتمل",
    statusCancelled: "ملغي",
  },
  agent: {
    title: "الوكلاء",
    comingSoon: "قريباً",
    desc: "لوحة تحكم الوكلاء والميزات القادمة قريباً",
    dashboard: "لوحة تحكم الوكيل",
    comingSoonDesc: "ميزات الوكيل قادمة قريباً",
    viewTickets: "عرض التذاكر",
    backHome: "العودة للرئيسية",
  },
};

export default ar;
